const $ = jQuery;

const ToTopButton = {
  init: function () {
    this.toTopBtn = document.getElementById("toTopBtn");
    this.setupClickListener();
  },

  setupClickListener: function () {
    this.toTopBtn.addEventListener("click", function (event) {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  },
};

export default ToTopButton;
